import { IconButton } from "@mui/material";
import { AddButton } from "app/components/Button/AddButton";
import { FilterSelect } from "app/components/FilterSelect";
import { ThreedotIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  selectCustomersStatusFilter,
  selectCustomerStatusLabelKey,
} from "../../redux/selector";
import { customersActions } from "../../redux/slice";
import { CustomerStatus, CustomerStatusFilter } from "../../types";
import { useStyles } from "./styles";

const STATUS_OPTIONS: CustomerStatusFilter[] = [
  "ALL",
  CustomerStatus.ACTIVE,
  CustomerStatus.INACTIVE,
];

const ActionBar = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const statusFilter = useSelector(selectCustomersStatusFilter);

  const getStatusLabel = (value: CustomerStatusFilter) => {
    if (value === "ALL") {
      return t("CUSTOMERS.STATUS_FILTER.ALL");
    }

    return t(selectCustomerStatusLabelKey(value));
  };

  return (
    <div className={styles.root} dir="ltr">
      <div className={styles.actions}>
        <AddButton
          label={t("CUSTOMERS.ACTIONS.ADD_CUSTOMER")}
          onClick={() => dispatch(customersActions.openAddModal())}
        />
        <IconButton size="small" className={styles.iconButton}>
          <ThreedotIcon />
        </IconButton>
      </div>

      <FilterSelect
        label={t("CUSTOMERS.STATUS_FILTER.LABEL")}
        value={statusFilter}
        options={STATUS_OPTIONS}
        getOptionLabel={getStatusLabel}
        onChange={(value) => {
          dispatch(customersActions.setCustomersStatusFilter(value));
          dispatch(customersActions.getCustomersList());
        }}
      />
    </div>
  );
};

export default ActionBar;
